export default theme => ({
  icon: { color: theme.palette.secondary.main },
  avatarRoot: {
    borderRadius: 9,
    color: '#fff',
    backgroundColor: '#13b940',
  },
  button: {
    margin: theme.spacing.unit,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    '@media (min-width: 1191px)': {
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    '@media (max-width: 1190px)': {
      marginBottom: 5,
    },
  },
  panelContent: {
    position: 'relative',
    padding: '13px 60px 11px 81px',
    width: '100%',
  },
  panelContentModal: {
    position: 'relative',
    padding: '13px 60px 11px 81px',
    width: '100%',
  },
  panelContentWhenAssigningUsers: {
    position: 'relative',
    padding: '13px 60px 11px 81px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      minHeight: 113,
    },
  },
  panel: {
    backgroundColor: '#fff',
    padding: 0,
    minHeight: 84,
    '&:hover': {
      '&$panelCheckbox': {
        display: 'inline-flex',
      },
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 133,
    },
    borderBottom: '1px solid #e0e0e0',
    borderRight: '1px solid #e0e0e0',
  },
  avatar: {
    position: 'absolute',
    right: 240,
    top: '50%',
    transform: 'translate(0, -50%)',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      top: 'auto',
      right: 'auto',
    },
  },
  avatarLabel: {
    position: 'absolute',
    left: 49,
    top: '50%',
    transform: 'translate(0, -50%)',
    [theme.breakpoints.down('sm')]: {
      right: 'auto',
      left: 14,
      top: 'auto',
      bottom: -5,
      transform: 'none',
    },
  },
  avatarLabelTypography: {
    fontSize: theme.typography.pxToRem(15),
    maxWidth: 177,
  },
  select: {
    position: 'absolute',
    right: 121,
    top: '50%',
    transform: 'translate(0, -50%)',
    [theme.breakpoints.down('sm')]: {
      right: 'auto',
      left: 73,
      top: 'auto',
      bottom: 15,
      transform: 'none',
    },
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    '@media (max-width: 1190px)': {
      marginBottom: 5,
    },
  },
  panelCheckbox: { display: 'none' },
  colorDefault: { color: '#fff' },
  left: {
    position: 'absolute',
    left: 19,
    top: '50%',
    transform: 'translate(0, -50%)',
  },
  right: {
    position: 'absolute',
    right: 50,
    top: '-9px',
  },
  container: {
    listStyle: 'none',
  },
  checkbox: {
    position: 'absolute',
    left: '-4px',
    top: '50%',
    transform: 'translate(0, -50%)',
  },
  checkboxContainer: {
    position: 'relative',
  },
  selectMenu: {
    padding: '8.5px 24px 8.5px 7px',
  },
  notchedOutline: {
    borderRadius: 28,
  },
  dates: {
    maxWidth: 'calc(100% - 240px)',
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(11),
    },
  },
  dateInfo: {
    '@media (max-width: 1190px)': {
      display: 'block',
    },
  },
  date: {
    color: theme.palette.secondary.main,
    display: 'inline-block',
    marginRight: 15,
    '@media (max-width: 1190px)': {
      marginRight: 0,
    },
  },
})
